/**
 * @file login页
 * @author fengfaxia(fengfaxia@baidu.com))
 * Copyright (c) 2018-08-17 Baidu
 */

import React from 'react';
import {Dropdown, Icon, Menu} from 'antd';
// import {getLoginUrl} from '../../common/util';
import {envConfig} from '../../common/envConfig';

export default class Login extends React.Component {
    constructor(argus) {
        super(argus);
        const location = window.location;
        const {passportUrl, dwzBaiduDomain} = envConfig();
        const registerUrl = `${passportUrl}/v2/?reg&tt=1541069922965&overseas=&gid=FCC74DB-D256-448A-8E87-88A7C6ABD01E`
            + `&tpl=pp&u=${dwzBaiduDomain}/redirect?url=${location.href}`;
        // 兼容IE10
        const dwzOrigin = location.protocol + '//' + location.hostname + (location.port ? ':' + location.port : '');
        const logoutUrl = `${dwzBaiduDomain}/logout?url=${dwzOrigin}`;
        this.state = {
            registerUrl,
            logoutUrl
        };
    }
    onLogin() {
        //如果登录状态为'false'未登录,跳转登录页面
        // if (localStorage.getItem('login_status') === 'false') {
        //     window.location.href = getLoginUrl();
        // }
        // localStorage.removeItem('login_status');
        window.open('https://console.bce.baidu.com/dwz/?channel=portal', '_blank');

        /* eslint-disable */
        _hmt.push(['_trackEvent', '首页', 'hompage_click_login', '点击登录']);
    }
    onRegister() {
        /* eslint-disable */
        _hmt.push(['_trackEvent', '首页', 'hompage_click_register', '点击注册']);
        // window.location.href = this.state.registerUrl;
        window.open('https://console.bce.baidu.com/dwz/?channel=portal', '_blank');
    }
    onLogout() {
        _hmt.push(['_trackEvent', '首页', 'hompage_click_logout', '点击退出']);
        window.location.href = this.state.logoutUrl;
    }
    render() {
        const userName = this.props.userName;
        const inArrears = this.props.inArrears;
        const menu = (
             <Menu>
              <Menu.Item key="logout">
                <a onClick={() => this.onLogout()} className="logout">退出</a>
              </Menu.Item>
            </Menu>
          );
        return (
            <div className="login-container">
            {
                userName
                // 判断登录用户是否欠费
                ? inArrears
                ? <Dropdown overlay={menu}>
                    <span>{userName} <Icon type="down" />
                    <p className="arrears">已欠费</p>
                    </span>
                </Dropdown>
                : <Dropdown overlay={menu}>
                    <span>{userName} <Icon type="down" /></span>
                </Dropdown>
                : <div>
                    <a className="account" onClick={() => this.onLogin()}>登录</a>
                    <a className="account" onClick={() => this.onRegister()}>注册</a>
                </div>
             }
            </div>
        );
    }
}
